import React, { createContext, useContext, useMemo } from 'react';

// export const IMAGE_VIEWER_DEFAULT_VALUE = {
//   StudyInstanceUIDs: [],
//   setImageViewer: () => {},
// };

interface ImageViewerProviderProps {
  StudyInstanceUIDs: string[];
  StudyList: {
    studyInstanceUid: string;
    date: string;
    description: string[];
    modalities: string[];
    numInstances: number;
    patientName: string;
    patientSex: string;
    patientDoB: string;
    patientId: string;
    visitId: string;
    procedureCode: string[];
    orderGroup: string[];
  }[];
  children: React.ReactNode;
}

export const ImageViewerContext = createContext(null);

export function ImageViewerProvider({
  StudyInstanceUIDs,
  StudyList,
  children,
}: ImageViewerProviderProps) {
  const value = useMemo(() => {
    return { StudyInstanceUIDs, StudyList };
  }, [StudyInstanceUIDs, StudyList]);

  return (
    <ImageViewerContext.Provider value={value}>
      {children}
    </ImageViewerContext.Provider>
  );
}

export const useImageViewer = () =>
  useContext(ImageViewerContext) as {
    StudyInstanceUIDs: ImageViewerProviderProps['StudyInstanceUIDs'];
    StudyList: ImageViewerProviderProps['StudyList'];
  };
